import mapFunction from './mapResources';

export default  mapFunction('tools_at_buildings', {
    isFetching: false,
    items: [] 
});